import { useEffect } from "react";

/**
 * Hook to run an effect only once when the component mounts
 */
export function useOnce(effect) {
  useEffect(() => {
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}